var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchaseRetuns(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.549 8.08h-3.54a1.452 1.452 0 0 0 0 2.903h1.714L25.25 21.666a.655.655 0 0 1-.641.51H11.423L8.002 7.323A2.49 2.49 0 0 0 5.56 5.38H2.452a1.452 1.452 0 0 0 0 2.903h2.792l3.511 15.243-.807 2.14a3.565 3.565 0 0 0 .403 3.285 3.565 3.565 0 0 0 2.93 1.536h13.035a1.452 1.452 0 0 0 0-2.904H11.28a.644.644 0 0 1-.542-.284.644.644 0 0 1-.075-.608l.608-1.611H24.61a3.545 3.545 0 0 0 3.47-2.76L30.962 9.86A1.449 1.449 0 0 0 29.55 8.08z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.279 16.318c.801 0 1.451-.65 1.451-1.452V6.344l1.83 1.737a1.45 1.45 0 1 0 1.999-2.106l-4.281-4.063a1.452 1.452 0 0 0-1.998 0l-4.282 4.063a1.45 1.45 0 1 0 1.998 2.106l1.831-1.738v8.523c0 .801.65 1.452 1.452 1.452z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseRetuns);
export default __webpack_public_path__ + "static/media/purchase-retuns.f325c366f3279cbe62cfe084f19017bf.svg";
export { ForwardRef as ReactComponent };